import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import {TopButtonPointAction, TopButtonPointEdit, TopButtonPointRemove} from "../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../utilities/TabUtilities";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import ReactTooltip from "react-tooltip";
import {Link} from "react-router-dom";
import LSService from "../../../../utilities/localStorageService/LSService";
import KlienciBiletyService from "../../KlienciBiletyService";
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import initialData from "../../../../utilities/initialData/initialData";
import acc from 'accounting'
import KartyMiesieczneTable from "./KartyMiesieczneTable";
import {ControlLabel} from "react-bootstrap";

export default class KartyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statusy: [
                {value: 'NOWA', label: 'nowa'},
                {value: 'PRZYJETA', label: 'przyjeta'},
                {value: 'GOTOWA', label: 'gotowa'},
                {value: 'ZWROCONA', label: 'zwrócona'}
            ],
            expandedRow: null,
            miesieczneNaKarcie: [],
            isLoading: false

        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.formatStatus = this.formatStatus.bind(this)
        this.renderKlient = this.renderKlient.bind(this)
        this.isExpandableRow = this.isExpandableRow.bind(this)
        this.onExpand = this.onExpand.bind(this)
        this.expandComponent = this.expandComponent.bind(this)
    }


    componentDidMount() {
    }


    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction onClick={() => this.onClickPrzedluz(row)} buttonIcon={'fa fa-plus'} buttonColor={'success'}
                                      titleContent={'Przedłuż na następny miesiąc'}/>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj kartę'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń kartę'}/>
            </div>
        )
    }

    onClickPrzedluz(obj) {
        let karta = Object.assign(obj, {przekierowacDoKart: true})
        LSService.ustawDaneKartyDoDodaniaMies(karta)
        this.props.history.push('/konfiguracja/zarzadzanie-biletami/bilety/dodaj-miesieczny')
    }

    formatStatus(cell, row) {
        if (Boolean(cell)) {

            let status = this.state.statusy.find(s => s.value == cell)
            if (Boolean(status)) {
                return (<div>
                    <TopSelect onChange={(e) => {
                        this.props.handleChangeStatus(e, row)
                    }}
                               value={status}
                               options={this.state.statusy}
                               clearable={false}
                    />
                </div>)
            }

        }
    }


    renderKierunek(cell, row) {
        if (cell === 1) {
            // w jedna stronę
            return <div title={'Przejazd tylko w jednym kierunku'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-long-arrow-right'}></i>
            </div>
        }
        else if (cell === 2) {
            return <div title={'Przejazd w obydwa kierunki'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-exchange'}></i>
            </div>
        }
        else return cell
    }

    renderOkres(cell, row) {
        if (cell === 'P1') {
            return <div title={'Pierwsza połowa miesiąca'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-adjust'} style={{transform: 'rotate(180deg)'}}></i>
            </div>
        }
        else if (cell === 'P2') {
            return <div title={'Druga połowa miesiąca'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-adjust'}></i>
            </div>
        }
        else if (cell === 'M1') {
            return <div title={'Cały miesiąc'} style={{textAlign: 'center', lineHeight: '30px'}}>
                <i className={'fa fa-circle'}></i>
            </div>

        }
        else return cell
    }

    renderKlient(cell, row) {

        if (Boolean(row.idKl)) {
            return (
                <div>
                    <div data-tip='' data-for={'klient_data' + row.idKl + '-' + row.idKa} data-place="bottom" className='tooltip_here'>
                        <Link to={'/zarzadzanie-klientami/klient/' + row.idKl} target={'_blank'}>
                            <span style={{fontSize:13}}>{cell}</span>
                        </Link>
                    </div>
                    <ReactTooltip id={'klient_data' + row.idKl + '-' + row.idKa}>
                        <div>
                            {
                                Boolean(row.imieKl) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-user'
                                                                        style={{marginRight: '5px'}}></i> {row.imieKl + ' ' + row.nazKl}
                                    </div> : ''
                            }{
                            Boolean(row.peselKl) ?
                                <div style={{lineHeight: '2em'}}><i className='fa fa-id-card-o'
                                                                    style={{marginRight: '5px'}}></i>Pesel: {row.peselKl}
                                </div> : ''
                        }
                            {
                                Boolean(row.nrTelKl) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-phone'
                                                                        style={{marginRight: '5px'}}></i>Telefon: {row.nrTelKl}
                                    </div> : ''
                            }
                            {
                                Boolean(row.emailKl) ?
                                    <div style={{lineHeight: '2em'}}><i className='fa fa-envelope'
                                                                        style={{marginRight: '5px'}}></i>Email: {row.emailKl}
                                    </div> : ''
                            }
                        </div>
                    </ReactTooltip>
                </div>
            )
        }
    }

    renderRodzaj(cell, row) {
        return (<span className={'label label-ebus-default'} style={{color: '#fff', background: row.kolor}} title={row.nazZniz}>{cell}</span>)
    }

    expandComponent(row) {
        return <div style={{borderBottom: '3px solid #83c33a', paddingBottom: '5px'}}>
            <div className={'well well-sm'} style={{marginBottom: '5px'}}>
                {
                    Boolean(this.state.isLoading) ?
                        <div id={'smallLoader'}>
                            <i className={'fa fa-circle-o-notch fa-spin'}></i>
                            <div>Trwa ładowanie...</div>
                        </div>
                        :
                        (this.state.miesieczneNaKarcie.length > 0) ?
                            <div>
                                <KartyMiesieczneTable miesieczneNaKarcie={this.state.miesieczneNaKarcie}/>
                            </div>
                            :
                            <TopAlertInformacja text={'Na tej karcie nie kupiono jeszcze biletu miesięcznego'}/>
                }
            </div>
        </div>

    }

    expandColumnComponent({isExpandableRow, isExpanded}) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ?
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-up'></i>)
                    :
                    (<i style={{display: "block", textAlign: "center"}} className='fa fa-lg fa-caret-down'></i>)
            )
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

    isExpandableRow(row) {
        if (Boolean(this.state.expandedRow))
            return this.state.expandedRow === row.idKa
        else
            return (true)
    }

    onExpand(cell, isExpanded) {

        if (isExpanded) {
            this.setState({expandedRow: cell, isLoading: true})
            KlienciBiletyService.pobierzBiletyMiesieczneNaKarcie(cell).then(function (response) {
                let arr = Array.from(response.data, item => {
                    return {
                        ...item,
                        statusSlownie: (item.status == 1) ? 'opłacony' : 'do opłaty',
                        miejscowosciBilet: item.nazMiOd + ' ' + item.nazMiDo,
                        platnosciInfo: item.platnosciTransakcja + ' ' + item.platnoscTpay,
                        miesiacSlownie: Boolean(initialData.returnArrayMiesiace().find(m => m.value === item.miesiac)) ? initialData.returnArrayMiesiace().find(m => m.value === item.miesiac).label : item.miesiac
                    }
                });

                this.setState({miesieczneNaKarcie: this.formatujBiletyMiesieczneNaKarcie(arr), isLoading: false})
            }.bind(this))
        }
        else this.setState({expandedRow: null, miesieczneNaKarcie: [], isLoading: false})
    }


    sprawdzCzyRokIMiesiacTenSam(obj1, obj2) {
        return (obj1.rok === obj2.rok && obj1.miesiac === obj2.miesiac)
    }

    formatujBiletyMiesieczneNaKarcie(array) {
        if (array.length === 0) return []

        else if (array.length === 1 || array[0].kierunek === 1) {
            return array
        }
        else {
            let newarr = []
            for (let i = 0; i < array.length; i++) {

                if (i === 0) {
                    // pierwszy
                    if (this.sprawdzCzyRokIMiesiacTenSam(array[0], array[1])) {
                        // jest dupliakcja

                        let obj = array[0]
                        obj = Object.assign(obj, {dwiestrony: true, calacena: (parseFloat(array[0].cena) + parseFloat(array[1].cena)).toFixed(2)})
                        newarr.push(obj);
                        i++
                    }
                    else {
                        newarr.push(array[0], array[1])
                    }
                }
                else if (i === array.length - 1) {
                    // ostatni
                    if (this.sprawdzCzyRokIMiesiacTenSam(array[i - 1], array[i])) {
                        // jest duplikacja
                        let obj = array[i - 1]
                        obj = Object.assign(obj, {dwiestrony: true, calacena: parseFloat(array[i - 1].cena) + parseFloat(array[i].cena)})
                        newarr.push(obj);
                        i++
                    }
                    else {
                        newarr.push(array[i - 1], array[i])
                    }

                }
                else {
                    // środkowe
                    if (this.sprawdzCzyRokIMiesiacTenSam(array[i], array[i + 1])) {
                        // jest duplikacja
                        let obj = array[i]
                        obj = Object.assign(obj, {dwiestrony: true, calacena: parseFloat(array[i].cena) + parseFloat(array[i + 1].cena)})
                        newarr.push(obj);
                        i++
                    }
                    else {
                        newarr.push(array[i], array[i + 1])
                    }
                }
            }

            return (newarr)
        }

    }

    formatOstatnioKupiony(cell, row) {
        let rok = Boolean(row.ostWaznyOd) ? row.ostWaznyOd.substr(0, 4) : '';
        let msc = Boolean(row.ostWaznyOd) ? initialData.returnArrayMiesiace().find(m => m.value === parseInt(row.ostWaznyOd.substring(5, 7))) : '';

        if (Boolean(cell)) {
            return (<div>
                <div>{rok + ', ' + msc.label}</div>
                <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic'}}>{row.ostWaznyOd + ' - ' + row.ostWaznyDo}</div>
            </div>)
        }

    }


    render() {

        const options = {
            sizePerPageList: [10, 15, 30, 50, 100],
            noDataText: 'Brak pasujących rekordów',
            onExpand: this.onExpand,
            expandParentClass: 'expand-parent',
            expandBy: 'column',

            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };

        return (
            <div>
                <div className={'pull-right'} style={{marginTop: '15px'}}>
                    <ControlLabel>Ilość kart: {this.props.pageable.totalElements}</ControlLabel>
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    ref={'bstable'}
                                    fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                    remote={true}
                                    pagination={true}
                                    options={options}
                                    hover
                                    expandableRow={this.isExpandableRow}
                                    expandComponent={this.expandComponent}
                                    expandColumnOptions={{
                                        expandColumnVisible: true,
                                        expandColumnComponent: this.expandColumnComponent,
                                        columnWidth: 30,
                                    }}
                    >
                        <TableHeaderColumn dataField='idKa' isKey thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort expandable={false}
                                           dataFormat={(cell,row)=>{return<span style={{fontSize:11}}>{cell}</span>}}
                        >ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrKarty'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                        >Nr karty</TableHeaderColumn>
                        <TableHeaderColumn dataField={'dataWydania'}
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                        >Data wydania</TableHeaderColumn>
                        <TableHeaderColumn dataField='klient'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                           dataFormat={this.renderKlient}
                        >Klient</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazMiOd'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                        >Od miejscowości</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazMiDo'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                        >Do miejscowości</TableHeaderColumn>
                        <TableHeaderColumn dataField='kierunek'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false}
                                           dataFormat={this.renderKierunek}
                        >Kierunek</TableHeaderColumn>
                        <TableHeaderColumn dataField='okres'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false}
                                           dataFormat={this.renderOkres}
                        >Okres</TableHeaderColumn>

                        <TableHeaderColumn dataField='ostWaznyOd' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                           dataFormat={this.formatOstatnioKupiony}
                        >Ostatnio kupiony</TableHeaderColumn>
                        <TableHeaderColumn dataField='ostCena'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Ost. cena</TableHeaderColumn>

                        <TableHeaderColumn dataField='rodz'
                                           thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} expandable={false}
                                           dataFormat={this.renderRodzaj}
                        >Rodzaj</TableHeaderColumn>
                        <TableHeaderColumn dataField='status'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} expandable={false}
                                           dataFormat={this.formatStatus}
                        >Status</TableHeaderColumn>

                        <TableHeaderColumn dataField='idKa'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} expandable={false}
                                           dataFormat={this.renderButtonyAkcji}
                        >{TabUtilities.returnAkcjeEdytujUsunPlusDodatkowaHtml('Przedłuż', '#333')}</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/karty/components/KartyTable.js